import TfcConnected from '../../../containers/source-integration/independent-integrations/tfc'

export const tfc = {
  component: TfcConnected,
  data: {
    title: 'Terraform Cloud Run task',
    tileKey: 'tfc',
  },
}
